export const LabsAnimation = {
  v: "5.12.1",
  fr: 24,
  ip: 0,
  op: 48,
  w: 281,
  h: 281,
  nm: "Labs",
  ddd: 0,
  assets: [
    {
      id: "comp_0",
      nm: "Main Beaker",
      fr: 24,
      layers: [
        {
          ddd: 0,
          ind: 1,
          ty: 4,
          nm: "Bubble 03",
          sr: 1,
          ks: {
            o: { a: 0, k: 100, ix: 11 },
            r: { a: 0, k: 0, ix: 10 },
            p: {
              a: 1,
              k: [
                {
                  i: { x: 0.1, y: 1 },
                  o: { x: 0.9, y: 0 },
                  t: 0,
                  s: [134.518, 170.018, 0],
                  to: [0, 0, 0],
                  ti: [0, 0, 0],
                },
                { t: 31, s: [137.518, 160.518, 0] },
              ],
              ix: 2,
              l: 2,
            },
            a: { a: 0, k: [-3.482, 31.518, 0], ix: 1, l: 2 },
            s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
          },
          ao: 0,
          shapes: [
            {
              ty: "gr",
              it: [
                {
                  d: 1,
                  ty: "el",
                  s: { a: 0, k: [7.035, 7.035], ix: 2 },
                  p: { a: 0, k: [0, 0], ix: 3 },
                  nm: "Ellipse Path 1",
                  mn: "ADBE Vector Shape - Ellipse",
                  hd: false,
                },
                {
                  ty: "st",
                  c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
                  o: { a: 0, k: 100, ix: 4 },
                  w: { a: 0, k: 2, ix: 5 },
                  lc: 1,
                  lj: 1,
                  ml: 4,
                  bm: 0,
                  nm: "Stroke 1",
                  mn: "ADBE Vector Graphic - Stroke",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [-3.482, 31.518], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Ellipse 1",
              np: 3,
              cix: 2,
              bm: 0,
              ix: 1,
              mn: "ADBE Vector Group",
              hd: false,
            },
          ],
          ip: 0,
          op: 120,
          st: 0,
          ct: 1,
          bm: 0,
        },
        {
          ddd: 0,
          ind: 2,
          ty: 4,
          nm: "Bubble 02",
          sr: 1,
          ks: {
            o: { a: 0, k: 100, ix: 11 },
            r: { a: 0, k: 0, ix: 10 },
            p: {
              a: 1,
              k: [
                {
                  i: { x: 0.1, y: 1 },
                  o: { x: 0.9, y: 0 },
                  t: 0,
                  s: [153.835, 156.835, 0],
                  to: [0, 0, 0],
                  ti: [0, 0, 0],
                },
                { t: 31, s: [155.335, 143.835, 0] },
              ],
              ix: 2,
              l: 2,
            },
            a: { a: 0, k: [13.335, 16.335, 0], ix: 1, l: 2 },
            s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
          },
          ao: 0,
          shapes: [
            {
              ty: "gr",
              it: [
                {
                  d: 1,
                  ty: "el",
                  s: { a: 0, k: [8.67, 8.67], ix: 2 },
                  p: { a: 0, k: [0, 0], ix: 3 },
                  nm: "Ellipse Path 1",
                  mn: "ADBE Vector Shape - Ellipse",
                  hd: false,
                },
                {
                  ty: "st",
                  c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
                  o: { a: 0, k: 100, ix: 4 },
                  w: { a: 0, k: 2, ix: 5 },
                  lc: 1,
                  lj: 1,
                  ml: 4,
                  bm: 0,
                  nm: "Stroke 1",
                  mn: "ADBE Vector Graphic - Stroke",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [13.335, 16.335], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Ellipse 1",
              np: 3,
              cix: 2,
              bm: 0,
              ix: 1,
              mn: "ADBE Vector Group",
              hd: false,
            },
          ],
          ip: 0,
          op: 120,
          st: 0,
          ct: 1,
          bm: 0,
        },
        {
          ddd: 0,
          ind: 3,
          ty: 4,
          nm: "Bubble 01",
          sr: 1,
          ks: {
            o: { a: 0, k: 100, ix: 11 },
            r: { a: 0, k: 0, ix: 10 },
            p: {
              a: 1,
              k: [
                {
                  i: { x: 0.1, y: 1 },
                  o: { x: 0.9, y: 0 },
                  t: 0,
                  s: [131.005, 146.505, 0],
                  to: [0, 0, 0],
                  ti: [0, 0, 0],
                },
                { t: 32, s: [128.505, 129.005, 0] },
              ],
              ix: 2,
              l: 2,
            },
            a: { a: 0, k: [-7.995, 16.005, 0], ix: 1, l: 2 },
            s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
          },
          ao: 0,
          shapes: [
            {
              ty: "gr",
              it: [
                {
                  d: 1,
                  ty: "el",
                  s: { a: 0, k: [12.01, 12.01], ix: 2 },
                  p: { a: 0, k: [0, 0], ix: 3 },
                  nm: "Ellipse Path 1",
                  mn: "ADBE Vector Shape - Ellipse",
                  hd: false,
                },
                {
                  ty: "st",
                  c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
                  o: { a: 0, k: 100, ix: 4 },
                  w: { a: 0, k: 2, ix: 5 },
                  lc: 1,
                  lj: 1,
                  ml: 4,
                  bm: 0,
                  nm: "Stroke 1",
                  mn: "ADBE Vector Graphic - Stroke",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [-7.995, 16.005], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Ellipse 1",
              np: 3,
              cix: 2,
              bm: 0,
              ix: 1,
              mn: "ADBE Vector Group",
              hd: false,
            },
          ],
          ip: 0,
          op: 120,
          st: 0,
          ct: 1,
          bm: 0,
        },
        {
          ddd: 0,
          ind: 4,
          ty: 4,
          nm: "Liquid",
          sr: 1,
          ks: {
            o: { a: 0, k: 100, ix: 11 },
            r: { a: 0, k: 0, ix: 10 },
            p: { a: 0, k: [140.5, 140.5, 0], ix: 2, l: 2 },
            a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
            s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
          },
          ao: 0,
          shapes: [
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 1,
                    k: [
                      {
                        i: { x: 0.1, y: 1 },
                        o: { x: 0.9, y: 0 },
                        t: 0,
                        s: [
                          {
                            i: [
                              [0, 0],
                              [0, 0],
                              [3.75, -5.25],
                              [0, 0],
                              [-1.5, 0],
                              [0, 0],
                            ],
                            o: [
                              [0, 0],
                              [0, 0],
                              [-3.75, 5.25],
                              [0, 0],
                              [7, 0],
                              [0, 0],
                            ],
                            v: [
                              [21.875, -10.875],
                              [-22.875, -10.875],
                              [-50.875, 38.625],
                              [-46.875, 45.375],
                              [46.375, 45.625],
                              [50.875, 38.875],
                            ],
                            c: true,
                          },
                        ],
                      },
                      {
                        t: 32,
                        s: [
                          {
                            i: [
                              [0, 0],
                              [0, 0],
                              [3.75, -5.25],
                              [0, 0],
                              [-1.5, 0],
                              [0, 0],
                            ],
                            o: [
                              [0, 0],
                              [0, 0],
                              [-3.75, 5.25],
                              [0, 0],
                              [7, 0],
                              [0, 0],
                            ],
                            v: [
                              [21.875, -10.875],
                              [-34.375, 10.625],
                              [-50.875, 38.625],
                              [-46.875, 45.375],
                              [46.375, 45.625],
                              [50.875, 38.875],
                            ],
                            c: true,
                          },
                        ],
                      },
                    ],
                    ix: 2,
                  },
                  nm: "Path 1",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "st",
                  c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
                  o: { a: 0, k: 100, ix: 4 },
                  w: { a: 0, k: 2, ix: 5 },
                  lc: 1,
                  lj: 1,
                  ml: 4,
                  bm: 0,
                  d: [
                    { n: "d", nm: "dash", v: { a: 0, k: 5, ix: 1 } },
                    { n: "g", nm: "gap", v: { a: 0, k: 6, ix: 2 } },
                    { n: "o", nm: "offset", v: { a: 0, k: 0, ix: 7 } },
                  ],
                  nm: "Stroke 1",
                  mn: "ADBE Vector Graphic - Stroke",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [0.183, 0.257], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Shape 1",
              np: 3,
              cix: 2,
              bm: 0,
              ix: 1,
              mn: "ADBE Vector Group",
              hd: false,
            },
          ],
          ip: 0,
          op: 120,
          st: 0,
          ct: 1,
          bm: 0,
        },
        {
          ddd: 0,
          ind: 5,
          ty: 0,
          nm: "Beaker",
          refId: "comp_1",
          sr: 1,
          ks: {
            o: { a: 0, k: 100, ix: 11 },
            r: { a: 0, k: 0, ix: 10 },
            p: { a: 0, k: [140.5, 140.5, 0], ix: 2, l: 2 },
            a: { a: 0, k: [140.5, 140.5, 0], ix: 1, l: 2 },
            s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
          },
          ao: 0,
          w: 281,
          h: 281,
          ip: 0,
          op: 120,
          st: 0,
          bm: 0,
        },
      ],
    },
    {
      id: "comp_1",
      nm: "Beaker",
      fr: 24,
      layers: [
        {
          ddd: 0,
          ind: 1,
          ty: 4,
          nm: "Shape Layer 2",
          sr: 1,
          ks: {
            o: { a: 0, k: 100, ix: 11 },
            r: { a: 0, k: 0, ix: 10 },
            p: { a: 0, k: [138, 140.5, 0], ix: 2, l: 2 },
            a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
            s: { a: 0, k: [-100, 100, 100], ix: 6, l: 2 },
          },
          ao: 0,
          shapes: [
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [-14.076, -3.441],
                        [0, 0],
                      ],
                      o: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0.256, -0.25],
                        [0, 0],
                      ],
                      v: [
                        [-1.088, -88.5],
                        [-28.698, -88.5],
                        [-28.698, -76.25],
                        [-15.915, -76.25],
                        [-15.915, -38],
                        [-59.631, 35.75],
                        [-50.939, 52.25],
                        [-1.599, 52.25],
                      ],
                      c: false,
                    },
                    ix: 2,
                  },
                  nm: "Path 1",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "st",
                  c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
                  o: { a: 0, k: 100, ix: 4 },
                  w: { a: 0, k: 2, ix: 5 },
                  lc: 1,
                  lj: 1,
                  ml: 4,
                  bm: 0,
                  nm: "Stroke 1",
                  mn: "ADBE Vector Graphic - Stroke",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [0.088, 0.199], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Shape 1",
              np: 3,
              cix: 2,
              bm: 0,
              ix: 1,
              mn: "ADBE Vector Group",
              hd: false,
            },
          ],
          ip: 0,
          op: 120,
          st: 0,
          ct: 1,
          bm: 0,
        },
        {
          ddd: 0,
          ind: 2,
          ty: 4,
          nm: "Shape Layer 1",
          sr: 1,
          ks: {
            o: { a: 0, k: 100, ix: 11 },
            r: { a: 0, k: 0, ix: 10 },
            p: { a: 0, k: [141, 140.5, 0], ix: 2, l: 2 },
            a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
            s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
          },
          ao: 0,
          shapes: [
            {
              ty: "gr",
              it: [
                {
                  ind: 0,
                  ty: "sh",
                  ix: 1,
                  ks: {
                    a: 0,
                    k: {
                      i: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [-13.765, -3.441],
                        [0, 0],
                      ],
                      o: [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0.25, -0.25],
                        [0, 0],
                      ],
                      v: [
                        [-1, -88.5],
                        [-28, -88.5],
                        [-28, -76.25],
                        [-15.5, -76.25],
                        [-15.5, -38],
                        [-58.25, 35.75],
                        [-49.75, 52.25],
                        [-1.5, 52.25],
                      ],
                      c: false,
                    },
                    ix: 2,
                  },
                  nm: "Path 1",
                  mn: "ADBE Vector Shape - Group",
                  hd: false,
                },
                {
                  ty: "st",
                  c: { a: 0, k: [1, 1, 1, 1], ix: 3 },
                  o: { a: 0, k: 100, ix: 4 },
                  w: { a: 0, k: 2, ix: 5 },
                  lc: 1,
                  lj: 1,
                  ml: 4,
                  bm: 0,
                  nm: "Stroke 1",
                  mn: "ADBE Vector Graphic - Stroke",
                  hd: false,
                },
                {
                  ty: "tr",
                  p: { a: 0, k: [0.088, 0.199], ix: 2 },
                  a: { a: 0, k: [0, 0], ix: 1 },
                  s: { a: 0, k: [100, 100], ix: 3 },
                  r: { a: 0, k: 0, ix: 6 },
                  o: { a: 0, k: 100, ix: 7 },
                  sk: { a: 0, k: 0, ix: 4 },
                  sa: { a: 0, k: 0, ix: 5 },
                  nm: "Transform",
                },
              ],
              nm: "Shape 1",
              np: 3,
              cix: 2,
              bm: 0,
              ix: 1,
              mn: "ADBE Vector Group",
              hd: false,
            },
          ],
          ip: 0,
          op: 120,
          st: 0,
          ct: 1,
          bm: 0,
        },
      ],
    },
  ],
  fonts: {
    list: [
      {
        fName: "FormaDJRDsp-Bold",
        fFamily: "Forma DJR Display",
        fStyle: "Bold",
        ascent: 69.9996948242188,
      },
    ],
  },
  layers: [
    {
      ddd: 0,
      ind: 1,
      ty: 0,
      nm: "Main Beaker",
      refId: "comp_0",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: {
          a: 1,
          k: [
            { i: { x: [0.1], y: [1] }, o: { x: [0.9], y: [0] }, t: 0, s: [0] },
            { t: 32, s: [25] },
          ],
          ix: 10,
        },
        p: { a: 0, k: [140.5, 140.5, 0], ix: 2, l: 2 },
        a: { a: 0, k: [140.5, 140.5, 0], ix: 1, l: 2 },
        s: { a: 0, k: [85, 85, 85], ix: 6, l: 2 },
      },
      ao: 0,
      ef: [
        {
          ty: 21,
          nm: "Fill",
          np: 9,
          mn: "ADBE Fill",
          ix: 1,
          en: 1,
          ef: [
            {
              ty: 10,
              nm: "Fill Mask",
              mn: "ADBE Fill-0001",
              ix: 1,
              v: { a: 0, k: 0, ix: 1 },
            },
            {
              ty: 7,
              nm: "All Masks",
              mn: "ADBE Fill-0007",
              ix: 2,
              v: { a: 0, k: 0, ix: 2 },
            },
            {
              ty: 2,
              nm: "Color",
              mn: "ADBE Fill-0002",
              ix: 3,
              v: {
                a: 1,
                k: [
                  {
                    i: { x: [0.66], y: [1] },
                    o: { x: [0], y: [0.66] },
                    t: 0,
                    s: [1, 1, 1, 1],
                  },
                  { t: 32, s: [0, 0, 0, 1] },
                ],
                ix: 3,
              },
            },
            {
              ty: 7,
              nm: "Invert",
              mn: "ADBE Fill-0006",
              ix: 4,
              v: { a: 0, k: 0, ix: 4 },
            },
            {
              ty: 0,
              nm: "Horizontal Feather",
              mn: "ADBE Fill-0003",
              ix: 5,
              v: { a: 0, k: 0, ix: 5 },
            },
            {
              ty: 0,
              nm: "Vertical Feather",
              mn: "ADBE Fill-0004",
              ix: 6,
              v: { a: 0, k: 0, ix: 6 },
            },
            {
              ty: 0,
              nm: "Opacity",
              mn: "ADBE Fill-0005",
              ix: 7,
              v: { a: 0, k: 1, ix: 7 },
            },
          ],
        },
      ],
      w: 281,
      h: 281,
      ip: 0,
      op: 120,
      st: 0,
      bm: 0,
    },
  ],
  markers: [],
  props: {},
  chars: [
    {
      ch: "L",
      size: 166,
      style: "Bold",
      w: 47.75,
      data: {
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [-0.604, 0],
                      [0, 0],
                      [0, 0.604],
                      [0, 0],
                      [0.554, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0.604, 0],
                      [0, 0],
                      [0, -0.604],
                      [0, 0],
                      [0, 0],
                    ],
                    o: [
                      [0, 0],
                      [0.554, 0],
                      [0, 0],
                      [0, -0.554],
                      [0, 0],
                      [0, 0],
                      [0, 0],
                      [0, -0.604],
                      [0, 0],
                      [-0.604, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0.655],
                    ],
                    v: [
                      [3.777, 0],
                      [47.031, 0],
                      [47.937, -0.957],
                      [47.937, -10.474],
                      [47.031, -11.38],
                      [18.43, -11.38],
                      [18.077, -36.154],
                      [18.379, -69.589],
                      [17.473, -70.496],
                      [3.777, -70.496],
                      [2.87, -69.589],
                      [3.323, -35.248],
                      [2.87, -0.957],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "L",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
            ],
            nm: "L",
            np: 3,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false,
          },
        ],
      },
      fFamily: "Forma DJR Display",
    },
    {
      ch: "a",
      size: 166,
      style: "Bold",
      w: 55.9,
      data: {
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [-14.703, 0],
                      [-3.625, 4.431],
                      [0, 0],
                      [-0.604, 0],
                      [0, 0],
                      [0, 0.655],
                      [0, 0],
                      [0, 0],
                      [0.604, 0],
                      [0, 0],
                      [-0.05, -0.604],
                      [0, 0],
                      [6.445, 0],
                      [0, -15.005],
                    ],
                    o: [
                      [6.546, 0],
                      [0, 0],
                      [-0.05, 0.604],
                      [0, 0],
                      [0.604, 0],
                      [0, 0],
                      [0, 0],
                      [0, -0.604],
                      [0, 0],
                      [-0.554, 0],
                      [0, 0],
                      [-3.525, -4.23],
                      [-14.099, 0],
                      [0, 15.106],
                    ],
                    v: [
                      [23.717, 1.007],
                      [39.024, -6.042],
                      [38.873, -0.957],
                      [39.729, 0],
                      [53.023, 0],
                      [53.929, -0.957],
                      [53.677, -25.882],
                      [53.929, -50.958],
                      [53.023, -51.865],
                      [39.629, -51.865],
                      [38.773, -50.908],
                      [39.024, -46.326],
                      [24.019, -52.872],
                      [1.259, -25.781],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "a",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
              {
                ind: 1,
                ty: "sh",
                ix: 2,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [7.352, 0],
                      [0, 11.682],
                      [-7.654, -0.201],
                      [0.101, -11.078],
                    ],
                    o: [
                      [-7.251, 0.101],
                      [0, -10.675],
                      [7.251, 0.101],
                      [-0.101, 10.977],
                    ],
                    v: [
                      [27.946, -9.064],
                      [16.667, -26.587],
                      [28.249, -42.801],
                      [39.326, -25.58],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "a",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
            ],
            nm: "a",
            np: 5,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false,
          },
        ],
      },
      fFamily: "Forma DJR Display",
    },
    {
      ch: "b",
      size: 166,
      style: "Bold",
      w: 55.9,
      data: {
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [-6.445, 0],
                      [0, 15.005],
                      [14.703, 0],
                      [3.575, -4.33],
                      [0, 0],
                      [0.554, 0],
                      [0, 0],
                      [0, -0.604],
                      [0, 0],
                      [0, 0],
                      [-0.604, 0],
                      [0, 0],
                      [0.05, 0.604],
                      [0, 0],
                    ],
                    o: [
                      [14.099, 0],
                      [0, -15.106],
                      [-6.445, 0],
                      [0, 0],
                      [0, -0.554],
                      [0, 0],
                      [-0.604, 0],
                      [0, 0],
                      [0, 0],
                      [0, 0.655],
                      [0, 0],
                      [0.604, 0],
                      [0, 0],
                      [3.525, 4.23],
                    ],
                    v: [
                      [32.277, 1.007],
                      [55.037, -26.083],
                      [32.579, -52.872],
                      [17.473, -46.024],
                      [17.523, -69.589],
                      [16.617, -70.496],
                      [3.273, -70.496],
                      [2.316, -69.589],
                      [2.618, -35.248],
                      [2.316, -0.957],
                      [3.273, 0],
                      [16.617, 0],
                      [17.523, -0.957],
                      [17.271, -5.539],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "b",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
              {
                ind: 1,
                ty: "sh",
                ix: 2,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [7.654, 0.201],
                      [-0.101, 11.078],
                      [-7.352, 0],
                      [0, -11.38],
                    ],
                    o: [
                      [-7.251, -0.101],
                      [0.101, -10.675],
                      [7.251, -0.101],
                      [0, 10.474],
                    ],
                    v: [
                      [28.047, -9.265],
                      [16.969, -26.486],
                      [28.349, -42.599],
                      [39.629, -25.479],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "b",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
            ],
            nm: "b",
            np: 5,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false,
          },
        ],
      },
      fFamily: "Forma DJR Display",
    },
    {
      ch: "s",
      size: 166,
      style: "Bold",
      w: 51.5,
      data: {
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [-15.056, 0],
                      [0, 10.876],
                      [0, 9.869],
                      [-4.935, 0],
                      [-0.806, -4.28],
                      [-0.604, 0],
                      [0, 0],
                      [0.101, 0.655],
                      [13.596, 0],
                      [0, -10.776],
                      [0, -9.869],
                      [5.942, 0],
                      [0.352, 5.64],
                      [0.604, 0],
                      [0, 0],
                      [0, -0.554],
                    ],
                    o: [
                      [14.049, 0],
                      [0, -22.055],
                      [0, -4.431],
                      [6.143, 0],
                      [0.101, 0.554],
                      [0, 0],
                      [0.604, 0],
                      [-0.957, -10.675],
                      [-13.998, 0],
                      [0, 21.753],
                      [0, 4.028],
                      [-7.1, 0],
                      [0, -0.554],
                      [0, 0],
                      [-0.604, 0],
                      [0.504, 11.43],
                    ],
                    v: [
                      [26.385, 1.208],
                      [50.706, -15.811],
                      [16.768, -37.665],
                      [24.825, -43.909],
                      [34.543, -36.96],
                      [35.55, -36.104],
                      [47.786, -36.104],
                      [48.692, -37.111],
                      [25.026, -53.073],
                      [2.367, -36.557],
                      [36.305, -14.502],
                      [27.141, -8.157],
                      [15.862, -16.264],
                      [14.905, -17.171],
                      [2.065, -17.171],
                      [1.158, -16.264],
                    ],
                    c: true,
                  },
                  ix: 2,
                },
                nm: "s",
                mn: "ADBE Vector Shape - Group",
                hd: false,
              },
            ],
            nm: "s",
            np: 3,
            cix: 2,
            bm: 0,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false,
          },
        ],
      },
      fFamily: "Forma DJR Display",
    },
  ],
};
